exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body\r\n{\r\n    \r\n    padding-top: 40px;\r\n}\r\n\r\n\r\n.input-group-addon\r\n{\r\n    background-color: rgb(50, 118, 177);\r\n    border-color: rgb(40, 94, 142);\r\n    color: rgb(255, 255, 255);\r\n}\r\n.form-control:focus\r\n{\r\n    background-color: rgb(50, 118, 177);\r\n    border-color: rgb(40, 94, 142);\r\n    color: rgb(255, 255, 255);\r\n}\r\n.panel\r\n{\r\n    \r\n    margin-top: 200px; \r\n/*    background-color: gray;*/\r\n}\r\n.master-div{\r\n/*  background-image:url('./header/img/bg2.png') !important;\r\n  \r\n     background-size: 100% !important;\r\n                width:100% !important;*/\r\n    border: solid border;\r\n    padding-top:.9rem;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/USer/Interviewfeedback/src/app/homepage/homepage.component.css
// module id = ../../../../../src/app/homepage/homepage.component.css
// module chunks = main